import { Icon } from '@/new/components/icon';
import { cn } from '@/new/lib/utils';

export function FormStep({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cn('w-full rounded-md border bg-gray-50/50 p-6', className)}>{children}</div>;
}

export function FormStepHeader({
  title,
  description,
  icon,
  action,
}: {
  title: string;
  description: string;
  icon: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-col gap-1 border-b pb-2">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Icon className={`${icon} h-4 w-4 text-gray-700`} />
          <h2 className="font-serif text-xl text-gray-900">{title}</h2>
        </div>
        {action}
      </div>
      <p className="text-sm text-gray-500">{description}</p>
    </div>
  );
}
